









































































import InputField from "./InputField.vue";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";

@Component({
  components: {
    InputField,
  },
  data: (vm: InputText) => ({
    inputValue: vm.value,
  }),
  computed: {
    ...mapGetters("ui", ["nightMode"]),
  },
})
export default class InputText extends Vue {
  @Prop({ default: null }) public label!: string | null;
  @Prop({ default: "" }) public placeholder!: string;
  @Prop({ required: true }) public name!: string;
  @Prop({ default: 6 }) public rows!: number;
  @Prop({ default: null }) public helperText!: string | null;
  @Prop({ default: false }) public isLarge!: boolean;
  @Prop({ default: false }) public isDisabled!: boolean;
  @Prop({ default: false }) public isInvalid!: boolean;
  @Prop({ default: false }) public isReadOnly!: boolean;
  @Prop({ default: undefined }) public value!: string;
  @Prop({ default: null }) public selectOptions!: Array<{ [key: string]: string }>;
  private inputType = "text";
  private isFocused = false;
  private inputValue = "";

  @Watch("value")
  public onValueChanged(value: string) {
    this.inputValue = value;
  }

  get model() {
    return this.inputValue;
  }

  set model(value: string) {
    this.inputValue = value;
  }

  private onInput(event: any) {
    this.$emit("input", event);
  }

  private onChange(event: any) {
    this.$emit("change", event);
  }

  get isDirty() {
    return (
      !!this.inputValue || this.inputType === "date" || this.inputType === "datetime-local" || this.inputType === "file"
    );
  }

  private onFocus() {
    this.isFocused = true;
  }

  private onBlur() {
    this.isFocused = false;
  }
}
